import { render, staticRenderFns } from "./EducationalVideos.vue?vue&type=template&id=64f7d422&scoped=true&"
import script from "./EducationalVideos.vue?vue&type=script&lang=js&"
export * from "./EducationalVideos.vue?vue&type=script&lang=js&"
import style0 from "./EducationalVideos.vue?vue&type=style&index=0&id=64f7d422&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f7d422",
  null
  
)

export default component.exports